// Geoserver base URL
export const geoserverUrl = 'https://geo.kungsong.com/geoserver';
// WFS URL for insured plots
export const WFS_INS_PLOT_INSURED_URL = 'https://geo.kungsong.com/geoserver/ins/wfs';
// WMS URL for ks workspace
export const GEO_REGION_URL = 'https://geo.kungsong.com/geoserver/ks/wms?service=WMS';
// WMS URL for ins workspace
export const INS_WMS_URL = 'https://geo.kungsong.com/geoserver/ins/wms?service=WMS';

// Plot WMS config
export const PLOT_WMS_URL = 'https://geo.kungsong.com/geoserver/ins/wms';
export const PLOT_WMS_LAYER = 'ins:ins__plot_2026';
export const PLOT_WMS_STYLES = {
  HOME: 'ins__plot_home',
  MAP_DEFAULT: 'ins__plot_default',
  MAP_BOUNDARY_ONLY: 'ins__plot_boundary_only',
  INSURE_APPLY: 'ins__plot_insure_apply',
  PLOT_DRAW: 'ins__plot_draw'
};

export const LAND_SUB_CATEGORY_LABELS = {
  A01: '耕地地块',
  A02: '永久大棚地块',
  A03: '果园地块',
  A99: '其他种植地块',
  B01: '畜牧养殖场',
  B02: '特种养殖场',
  B03: '水产养殖场',
  B99: '其他养殖场',
  C01: '林木斑块',
  C02: '草原斑块',
  C99: '其他林草斑块'
};
